import React from "react";
import { Button } from "@mui/material";
import { SettingIcon } from "../../CommonUI/Icon/SettingIcon";

interface ISettingButton {
    onClick?: () => void;
}

export const SettingButton = ({ onClick }: ISettingButton) => {
    return (
        <Button
            startIcon={<SettingIcon />}
            className="RuleHeader-button"
            data-testid="RuleSetting-button"
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                event.stopPropagation();
                if (onClick) {
                    onClick();
                }
            }}
        >
            Settings
        </Button>
    );
};
